import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import InternalUserAutocomplete from "../../../shared/InternalUserAutocomplete";
import { InternalUser } from "../../../types/app";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSave: (selectedAssignedTo: InternalUser | null) => void;
}
export default function ChangeAssignedToModal({ isOpen, setIsOpen, onSave }: Props) {
  const [selectedAssignedTo, setSelectedAssignedTo] = useState<InternalUser | null>({
    fullName: "",
    email: ""
  } as InternalUser);

  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} fullWidth>
        <DialogTitle>Assign To:</DialogTitle>
        <DialogContent sx={{ marginTop: "35px" }}>
          <InternalUserAutocomplete
            sx={{ width: 220 }}
            value={selectedAssignedTo}
            onChange={(val) => {
              setSelectedAssignedTo(val as InternalUser | null);
            }}
            label="Assigned to"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={() => onSave(selectedAssignedTo)}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
